__turbopack_context__.v({
  "extendTextContent": "ExtendTextContent-module-scss-module__uH-QeW__extendTextContent",
  "extendTextContentDense": "ExtendTextContent-module-scss-module__uH-QeW__extendTextContentDense",
  "fade-in": "ExtendTextContent-module-scss-module__uH-QeW__fade-in",
  "no-transform": "ExtendTextContent-module-scss-module__uH-QeW__no-transform",
  "rotate": "ExtendTextContent-module-scss-module__uH-QeW__rotate",
  "textContent": "ExtendTextContent-module-scss-module__uH-QeW__textContent",
  "textContentTruncated": "ExtendTextContent-module-scss-module__uH-QeW__textContentTruncated",
});
